export default function TrendingSearches({ trendingSearches = [], onSearch }) {
    return (
        <div>
            <h3 className="mb-3 text-xs font-semibold tracking-[0.25em] text-muted-foreground uppercase">
                Trending Searches
            </h3>

            <div className="flex flex-wrap gap-2">
                {trendingSearches.map((search) => (
                    <button
                        key={search}
                        type="button"
                        onClick={() => onSearch(search)}
                        className="rounded-full border border-border bg-white px-4 py-2 text-sm transition focus:ring-2 focus:ring-ring focus:outline-none"
                    >
                        {search}
                    </button>
                ))}
            </div>
        </div>
    );
}
